import { render, staticRenderFns } from "./ParcelaTabContent.vue?vue&type=template&id=68f52883&scoped=true"
import script from "./ParcelaTabContent.vue?vue&type=script&lang=js"
export * from "./ParcelaTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f52883",
  null
  
)

export default component.exports